<template>
    <div class="chat-header">
        <ChatCloseSettingsButton
            :contact="contact"
            :autoTranslateEnabled="autoTranslateEnabled"
            :debugModeEnabled="debugModeEnabled"
            @autoTranslateChanged="autoTranslateChanged"
            @debugModeChanged="debugModeChanged"
            :is-watching="isWatching"
        />
        <TranslateDetected :contact="contact" @auto-translate="autoTranslateChanged" />
    </div>
</template>
<script>
import { mapMutations, mapState } from "vuex";
import { log2 } from "../../../utils/log2";
import { capitalize } from "../../../utils/utils";
import ChatCloseSettingsButton from "./ChatCloseSettingsButton.vue";
import TranslateDetected from "../TranslateDetected.vue";

const log = log2("ChatHeader");
export default {
    name: "ChatHeader",
    components: {
        TranslateDetected,
        ChatCloseSettingsButton,
    },
    props: {
        contact: {
            type: Object,
            default: () => ({}),
        },
        isWatching: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapState({
            autoTranslate: (state) => state.chat.autoTranslate,
        }),
    },
    data: () => ({
        autoTranslateEnabled: false,
        debugModeEnabled: false,
    }),
    mounted: function () {
        this.autoTranslateEnabled = this.autoTranslate.includes(this.contact.lastConversation._id);
    },
    methods: {
        ...mapMutations({
            setAutoTranslate: "chat/SET_AUTO_TRANSLATE",
        }),
        capitalize,
        autoTranslateChanged(val) {
            const fn = () => {
                this.autoTranslateEnabled = val;
                this.setAutoTranslate({
                    id: this.contact.lastConversation._id,
                    state: val,
                });
                if (val) {
                    this.$message.success({
                        content: `${this.$t("message.autoTranslate")} ${this.$t("message.on")}`,
                        duration: 3,
                        key: "translate",
                    });
                } else {
                    this.$message.warning({
                        content: `${this.$t("message.autoTranslate")} ${this.$t("message.off")}`,
                        duration: 3,
                        key: "translate",
                    });
                }
            };
            this.$feature.beforeAutoTranslation(fn);
        },
        debugModeChanged(val) {
            this.debugModeEnabled = val;
            this.$emit('debugModeChanged', val);
            if (val) {
                this.$message.success({
                    content: "Chatbot Debug Mode Açık",
                    duration: 3,
                    key: "debug",
                });
            } else {
                this.$message.info({
                    content: "Chatbot Debug Mode Kapalı",
                    duration: 3,
                    key: "debug",
                });
            }
        },
    },
    watch: {
        autoTranslate: {
            deep: true,
            handler() {
                this.autoTranslateEnabled = this.autoTranslate.includes(this.contact.lastConversation._id);
            },
        },
    },
};
</script>
